import { createContext, Dispatch, FC, SetStateAction, useState } from 'react'
import { GuestType } from 'src/api/api.generated';

type Totem = { id: string; eventId: string; reservedResourceId: string; customerId: string | null; guestType: GuestType | null }

type TotemContext = {
  totem: Totem
  setTotem: Dispatch<SetStateAction<Totem>>
}

export const TotemContext = createContext({ totem: { id: '', eventId: '', reservedResourceId: '', customerId: null, guestType: null } } as TotemContext)

export const TotemProvider: FC = ({ children }) => {
  const [totem, setTotem] = useState<Totem>({ id: '', eventId: '', reservedResourceId: '', customerId: null, guestType: null })

  return <TotemContext.Provider value={{ totem, setTotem }}>{children}</TotemContext.Provider>
}
